import { Client, Account, Databases, Storage } from 'appwrite';

// ============================================
// APPWRITE CLIENT CONFIGURATION
// ============================================
const client = new Client();

client
  .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT)
  .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID);

// ============================================
// APPWRITE SERVICES
// ============================================
export const account = new Account(client);
export const databases = new Databases(client);
export const storage = new Storage(client);

export { client };
export default client;
